<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Contact Us Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginContactText1" class="d-block">Add instruction about appointment</label>
                                                                <div>
                                                                    <ckeditor id="PreLoginContactText1"
                                                                        v-model="webinarContentData.PreLoginContactText1" :config="editorConfig">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.webinarContentData.PreLoginContactText1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <b-form-group
                                                                label="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)"
                                                                label-for="uploadingPath">
                                                                <b-form-input type="text" id="uploadingPath"
                                                                    v-model="contentConfig.uploadingPath" name="uploadingPath"
                                                                    :state="$v.contentConfig.uploadingPath.$dirty ? !$v.contentConfig.uploadingPath.$error : null"
                                                                    placeholder="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 3"
                                                                        label-for="PreLoginContactImage1">
                                                                        <b-form-file id="PreLoginContactImage1"
                                                                            v-model="contentImages.PreLoginContactImage1"
                                                                            name="PreLoginContactImage1" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${webinarContentData.PreLoginContactImage1}`"
                                                                        class=" img-fluid" alt="">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';


Vue.use(CKEditor);

export default {
    name: "scott_message",
    mixins: [validationMixin],
    data() {
        return {
            contentImages:{
                PreLoginContactImage1:[]
            },
            contentConfig: {
                uploadingPath: "images/Content Images/Home Page"
            },
            webinarContentData: {
                PreLoginContactText1: "",
                PreLoginContactImage1:"",
            },
            editorConfig: { 
                versionCheck: false 
            }
        }
    },
    validations: {
        webinarContentData: {
            PreLoginContactText1: {
                required
            },
            PreLoginAboutUsText2: {
                required
            },
            PreLoginAboutUsText3: {
                required
            },
            PreLoginAboutUsText4: {
                required
            },
        },
        contentConfig: {
            uploadingPath: ""
        }
    },
    methods: {
        updateHomeContent() {
            this.$v.webinarContentData.$touch();
            if (this.$v.webinarContentData.$anyError) {
                return;
            }
            API.updateHomeContent({...this.webinarContentData,...this.contentConfig,...this.contentImages}, this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification(res, 'success')
        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.webinarContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
